var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-header"},[_c('span',{staticClass:"icon-block",on:{"click":_vm.goBack}},[_c('van-icon',{attrs:{"name":"arrow-left"}}),_c('span',[_vm._v("返回")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }